//import SorterWasm from './sorter.wasm';  //wasm加载报错： (Note that you need plugins to import files that are not JavaScript)
 
 const SorterWasm = "AGFzbQEAAAAADwhkeWxpbmsuMAEEAAAAAAEhA2AAAGAWf39/f39/f39/f39/f39/f39/f39/fwBgAAF/AhIBA2VudgZtZW1vcnkCAwCAgAQDBAMAAQIHOQMRX193YXNtX2NhbGxfY3RvcnMAAAtzb3J0SW5kZXhlcwABE2Vtc2NyaXB0ZW5fdGxzX2luaXQAAgqSBgMDAAELhgYDAXwCewJ9An8gCyoCCLv9FCALKgIYu/0iAf0MAAAAAABAj0AAAAAAAECPQP3yASIX/SEBIhaZRAAAAAAAAOBBYwRAIBaqDAELQYCAgIB4CyEMAn8gF/0hACIWmUQAAAAAAADgQWMEQCAWqgwBC0GAgICAeAshDQJ/IAsqAii7RAAAAAAAQI9AoiIWmUQAAAAAAADgQWMEQCAWqgwBC0GAgICAeAshCwJAIBEgEGsiAyARSSIORQ0AIA39ESAM/RwBIAv9HAIhGEH4////ByEMQYiAgIB4IQ0gAyEQA0AgCSAQQQJ0aiABIBBBBHRq/QAAACAY/bUBIhf9GwAgF/0bAWogF/0bAmoiCzYCACALIAwgCyAMSBshDCALIA0gCyANShshDSAQQQFqIhAgEUcNAAsgDkUNACAPQQFrsyANsiAMspOVIRkgAyELA0ACfyAZIAkgC0ECdGoiASgCACAMa7KUIhqLQwAAAE9dBEAgGqgMAQtBgICAgHgLIRAgASAQNgIAIAogEEECdGoiASABKAIAQQFqNgIAIAtBAWoiCyARRw0ACwsgD0ECTwRAIAooAgAhEEEBIQsDQCAKIAtBAnRqIgEgASgCACAQaiIQNgIAIAtBAWoiCyAPRw0ACwsgAyARSARAIBEhEANAIAIgESAKIAkgEEEBayIQQQJ0IgFqKAIAQQJ0aiIPKAIAIhJrIgxBDGwiC2ogACAQQQR0aioCADgCACACIAtBBGoiDWogACABQQFyIhNBAnRqKgIAOAIAIAIgC0EIaiIOaiAAIAFBAnIiFEECdGoqAgA4AgAgBSAMQQJ0aiIMIAEgBGoiAS0AADoAACAMIAQgE2otAAA6AAEgDCAEIBRqLQAAOgACIAwgAS0AAzoAAyAHIAtqIAYgEEEYbGoiASoCADgCACAHIA1qIAEqAgQ4AgAgByAOaiABKgIIOAIAIAggC2ogASoCDDgCACAIIA1qIAEqAhA4AgAgCCAOaiABKgIUOAIAIA8gEkEBazYCACADIBBIDQALCwsEAEEACw==";

 

//sortIndexes 按照深度排序 

function sortWorker(self) {

    let wasmInstance;
    let wasmMemory;
    let useSharedMemory;
    let integerBasedSort;
    let dynamicMode;
    let splatCount;
    let indexesToSortOffset; //存储首地址
    let sortedIndexesOffset = 0;
    let transformIndexesOffset;
    let transformsOffset;
    let precomputedDistancesOffset;
    let mappedDistancesOffset;
    let frequenciesOffset;
    let centersFloatOffset, centersIntOffset,  sortedCentersOffset;  //
    let colorsOffset, sortedColorsOffset,   covsOffset, sortedCovs1Offset, sortedCovs2Offset;
    let modelViewProjOffset;
    let countsZero;
    let sortedIndexesOut;
    let dataInited 
    let Constants; 
    let memoryRequiredOut 
    let sortedBufferIndex = 0 
    let splatEnableSwapOut   
    /* const uintToFloat = (function(){ 
        const int32View = new Int32Array(1);
        const floatView = new Float32Array(int32View.buffer);
        
        return function(f) {
            int32View[0] = f;
            return floatView[0];
        }; 
    })(); */
    
    function sort(splatSortCount, splatRenderCount, modelViewProj,
                  usePrecomputedDistances, /* copyIndexesToSort, */ copyPrecomputedDistances, copyTransforms) {
        const sortStartTime = performance.now();

        if(!dataInited){
            return self.postMessage( {
                'sortDone': true,
                'splatSortCount': splatSortCount,
                'splatRenderCount': splatRenderCount,
                'sortTime': 0
            })
        }

        //console.log('startSort')

        if (!useSharedMemory) {
            /* const indexesToSort = new Uint32Array(wasmMemory, indexesToSortOffset, copyIndexesToSort.byteLength / Potree.defines.gs3d.BytesPerInt);
            indexesToSort.set(copyIndexesToSort); */
            const transforms = new Float32Array(wasmMemory, transformsOffset, copyTransforms.byteLength / Constants.BytesPerFloat);
            transforms.set(copyTransforms);
            if (usePrecomputedDistances) {
                let precomputedDistances;
                if (integerBasedSort) {//可以提高速度，但可能溢出。默认是true
                    precomputedDistances = new Int32Array(wasmMemory, precomputedDistancesOffset,
                                                          copyPrecomputedDistances.byteLength / Constants.BytesPerInt);
                } else {
                    precomputedDistances = new Float32Array(wasmMemory, precomputedDistancesOffset,
                                                            copyPrecomputedDistances.byteLength / Constants.BytesPerFloat);
                }
                precomputedDistances.set(copyPrecomputedDistances);
            }
        }

        if (!countsZero) countsZero = new Uint32Array(Constants.DepthMapRange);
        
        new Float32Array(wasmMemory, modelViewProjOffset, 16).set(modelViewProj);//由于新数组已经与 WebAssembly 内存关联，实际上是将 modelViewProj 的数据复制到了 WebAssembly 内存的指定位置。
        new Uint32Array(wasmMemory, frequenciesOffset, Constants.DepthMapRange).set(countsZero);
        
        
        const sortStartTime1 = performance.now();
        
        const swapBufferOffset = (splatEnableSwapOut && sortedBufferIndex == 1) ? memoryRequiredOut : 0  
        
        
        wasmInstance.exports.sortIndexes(centersFloatOffset, centersIntOffset,   sortedCentersOffset + swapBufferOffset,     precomputedDistancesOffset, 
                                         colorsOffset,   sortedColorsOffset + swapBufferOffset,   
                                         covsOffset,    sortedCovs1Offset + swapBufferOffset,    sortedCovs2Offset + swapBufferOffset,
                                         
                                         
                                         mappedDistancesOffset, frequenciesOffset, modelViewProjOffset,
                                          sortedIndexesOffset,  transformIndexesOffset, transformsOffset,
                                         Constants.DepthMapRange, splatSortCount, splatRenderCount,
                                         splatCount, usePrecomputedDistances, integerBasedSort,
                                         dynamicMode);
  
  
        const sortMessage = {
            'sortDone': true,
            'splatSortCount': splatSortCount,
            'splatRenderCount': splatRenderCount,
            'sortTime': 0,
            sortedBufferIndex 
            /* datas */
        };
        
        splatEnableSwapOut && (sortedBufferIndex = sortedBufferIndex == 1 ? 0 : 1)
        
        
        /* if (!useSharedMemory) {
            const sortedIndexes = new Uint32Array(wasmMemory, sortedIndexesOffset, splatRenderCount);
            if (!sortedIndexesOut || sortedIndexesOut.length < splatRenderCount) {
                sortedIndexesOut = new Uint32Array(splatRenderCount);
            }
            sortedIndexesOut.set(sortedIndexes);
            sortMessage.sortedIndexes = sortedIndexesOut;
        } */
        const sortEndTime = performance.now();

        sortMessage.sortTime = sortEndTime - sortStartTime;

        self.postMessage(sortMessage);
    }

    self.onmessage = (e) => {
       if (e.data.sort) {//请求sort
            const renderCount = e.data.sort.splatRenderCount || 0;
            const sortCount = e.data.sort.splatSortCount || 0;
            const usePrecomputedDistances = e.data.sort.usePrecomputedDistances;

            let copyIndexesToSort;
            let copyPrecomputedDistances;
            let copyTransforms;
            if (!useSharedMemory) {
                //copyIndexesToSort = e.data.sort.indexesToSort;
                copyTransforms = e.data.sort.transforms;
                if (usePrecomputedDistances) copyPrecomputedDistances = e.data.sort.precomputedDistances;
            }
            sort(sortCount, renderCount, e.data.sort.modelViewProj, usePrecomputedDistances,
                        copyPrecomputedDistances, copyTransforms);
                 
        } else if (e.data.init) {//初始化 分配空间
            // Yep, this is super hacky and gross :(
            
            Constants = e.data.init.Constants;

            splatCount = e.data.init.splatCount;
            useSharedMemory = e.data.init.useSharedMemory;
            integerBasedSort = e.data.init.integerBasedSort;
            dynamicMode = e.data.init.dynamicMode;
            splatEnableSwapOut = e.data.init.splatEnableSwapOut
            
            
            const CENTERS_BYTES_PER_ENTRY = integerBasedSort ? (Constants.BytesPerInt * 4) : (Constants.BytesPerFloat * 4);

            const sorterWasmBytes = new Uint8Array(e.data.init.sorterWasmBytes);

            const matrixSize = 16 * Constants.BytesPerFloat;
            const memoryRequiredForIndexesToSort = splatCount * Constants.BytesPerInt;
            const memoryRequiredForCenters = splatCount * CENTERS_BYTES_PER_ENTRY;
            const memoryRequiredForCentersOut = splatCount * Constants.BytesPerFloat * 3;
            //add:------
            const memoryRequiredForColors = splatCount * 1 * 4; //4 byte
            const memoryRequiredForCovsHalf  = splatCount * Constants.BytesPerFloat * 3; 
            
            
           
            const memoryRequiredForModelViewProjectionMatrix = matrixSize;
            const memoryRequiredForPrecomputedDistances = integerBasedSort ?
                                                          (splatCount * Constants.BytesPerInt) : (splatCount * Constants.BytesPerFloat);
            const memoryRequiredForMappedDistances = splatCount * Constants.BytesPerInt;
            //const memoryRequiredForSortedIndexes = splatCount * Constants.BytesPerInt;
            const memoryRequiredForIntermediateSortBuffers = Constants.DepthMapRange * Constants.BytesPerInt * 2;
            const memoryRequiredforTransformIndexes = dynamicMode ? (splatCount * Constants.BytesPerInt) : 0;
            const memoryRequiredforTransforms = dynamicMode ? (Constants.MaxScenes * matrixSize) : 0;
            const extraMemory = Constants.MemoryPageSize * 4/* 32 */;


            
            const totalRequiredMemory = //memoryRequiredForIndexesToSort +
                                        memoryRequiredForCenters * (integerBasedSort ? 2 : 1)  +  //change !!
                                        memoryRequiredForCentersOut * 1 + 
                                        memoryRequiredForColors * 2 +  //add !!
                                        memoryRequiredForCovsHalf * 4 + //add !! 
                                        memoryRequiredForModelViewProjectionMatrix +
                                       // memoryRequiredForPrecomputedDistances +
                                        memoryRequiredForMappedDistances +
                                        memoryRequiredForIntermediateSortBuffers +
                                        //memoryRequiredForSortedIndexes +
                                        memoryRequiredforTransformIndexes +
                                        memoryRequiredforTransforms +
                                        extraMemory;
            //输出要双buffer    
            if(splatEnableSwapOut){
                memoryRequiredOut = memoryRequiredForCentersOut + memoryRequiredForColors + memoryRequiredForCovsHalf * 2
                totalRequiredMemory += memoryRequiredOut
            }                              
                                        
                                        
                                        
            const totalPagesRequired = Math.floor(totalRequiredMemory / Constants.MemoryPageSize ) + 1;
            const sorterWasmImport = {
                module: {},
                env: {
                    memory: new WebAssembly.Memory({
                        initial: totalPagesRequired * e.data.init.initialPagesRatio,   //2, //创建一个初始大小为 .. 页（每页64KiB）的内存实例
                        maximum: totalPagesRequired * 4,
                        shared: true,
                    }),
                }
            };
            WebAssembly.compile(sorterWasmBytes)
            .then((wasmModule) => {
                return WebAssembly.instantiate(wasmModule, sorterWasmImport);
            })
            .then((instance) => {
                wasmInstance = instance;
                //indexesToSortOffset = 0;
                //centersOffset = indexesToSortOffset + memoryRequiredForIndexesToSort;
                centersFloatOffset = 0
                
                if(integerBasedSort){
                    centersIntOffset = centersFloatOffset + memoryRequiredForCenters
                }
                 
                colorsOffset = (integerBasedSort ? centersIntOffset : centersFloatOffset) + memoryRequiredForCenters
                covsOffset = colorsOffset + memoryRequiredForColors
                
                sortedCentersOffset = covsOffset + memoryRequiredForCovsHalf * 2
                sortedColorsOffset = sortedCentersOffset + memoryRequiredForCentersOut
                sortedCovs1Offset = sortedColorsOffset + memoryRequiredForColors
                sortedCovs2Offset = sortedCovs1Offset + memoryRequiredForCovsHalf
                modelViewProjOffset = sortedCovs2Offset + memoryRequiredForCovsHalf
                
                if(splatEnableSwapOut){ 
                    modelViewProjOffset += memoryRequiredOut;
                } 
                /* 
                sortedCentersOffset = (integerBasedSort ? centersIntOffset : centersFloatOffset) +  memoryRequiredForCenters
                 
                colorsOffset = sortedCentersOffset + memoryRequiredForCentersOut  
                sortedColorsOffset = colorsOffset + memoryRequiredForColors
                
                
                covsOffset = sortedColorsOffset + memoryRequiredForColors  
                sortedCovs1Offset = covsOffset + memoryRequiredForCovsHalf * 2
                sortedCovs2Offset = sortedCovs1Offset + memoryRequiredForCovsHalf 
                
                modelViewProjOffset = sortedCovs2Offset + memoryRequiredForCovsHalf; */
                
                
                
                mappedDistancesOffset = modelViewProjOffset + memoryRequiredForModelViewProjectionMatrix
                /* precomputedDistancesOffset = modelViewProjOffset + memoryRequiredForModelViewProjectionMatrix;
                mappedDistancesOffset = precomputedDistancesOffset + memoryRequiredForPrecomputedDistances; */
                 
                frequenciesOffset = mappedDistancesOffset + memoryRequiredForMappedDistances; 
                
                //sortedIndexesOffset = frequenciesOffset + memoryRequiredForIntermediateSortBuffers; 
                 
                transformIndexesOffset = frequenciesOffset + memoryRequiredForIntermediateSortBuffers;
                transformsOffset = transformIndexesOffset + memoryRequiredforTransformIndexes;
                wasmMemory = sorterWasmImport.env.memory.buffer; //SharedArrayBuffer
                if (useSharedMemory) {
                    self.postMessage({
                        'sortSetupPhase1Complete': true,
                        '//indexesToSortBuffer': wasmMemory, 
                        'sortedIndexesOffset': sortedIndexesOffset,
                        //'precomputedDistancesBuffer': wasmMemory,
                        'precomputedDistancesOffset': precomputedDistancesOffset,
                        //'transformsBuffer': wasmMemory,
                        'transformsOffset': transformsOffset,
                         centersFloatOffset, centersIntOffset,  sortedCentersOffset,
                        colorsOffset, sortedColorsOffset,   covsOffset, sortedCovs1Offset, sortedCovs2Offset,
                       memoryRequiredOut,
                         
                        wasmMemory,
                        
                    });
                } else {
                    self.postMessage({
                        'sortSetupPhase1Complete': true
                    });
                }
            });
        }else if (e.data.dataInited) {
            dataInited = true
        } 
    };
}

export function createSortWorker(splatCount, integerBasedSort, dynamicMode ) {
    const useSharedMemory = true 
    const worker = new Worker(
        URL.createObjectURL(
            new Blob(['(', sortWorker.toString(), ')(self)'], {
                type: 'application/javascript',
            }),
        ),
    );

    const sorterWasmBinaryString = atob(SorterWasm);//二进制代码
    const sorterWasmBytes = new Uint8Array(sorterWasmBinaryString.length);
    for (let i = 0; i < sorterWasmBinaryString.length; i++) {
        sorterWasmBytes[i] = sorterWasmBinaryString.charCodeAt(i);
    }
  
    worker.postMessage({
        'init': {
            'sorterWasmBytes': sorterWasmBytes.buffer,
            'splatCount': splatCount,
            'useSharedMemory': useSharedMemory,
            'integerBasedSort': integerBasedSort,
            'dynamicMode': dynamicMode,
            splatEnableSwapOut: Potree.config.splatEnableSwapOut,
            initialPagesRatio : Potree.browser.isMobile ? 1 : 1.3,
            // Super hacky
            'Constants': {
                'BytesPerFloat': Potree.defines.gs3d.BytesPerFloat,
                'BytesPerInt': Potree.defines.gs3d.BytesPerInt,
                'DepthMapRange': Potree.defines.gs3d.DepthMapRange,
                'MemoryPageSize': Potree.defines.gs3d.MemoryPageSize,
                'MaxScenes': Potree.defines.gs3d.MaxScenes
            },           
        }
    });
    return worker;
}




/* 

    相关函数见  setupSortWorker     updateSplatSort     updateRenderIndexes  addSplatBuffers

    不share buffer 的话似乎不可行

 */
